module.exports = "https://cdn2-fs.clearscore.com/flux/images/35dec432cbbb1094c36e3da66c1bc20b.jpg";